
import * as THREE from 'three';
import { WalkThroughCameraControl, OrbitCameraControl } from '../../base';
import { ThreeView } from '../View3dWebCad';
import { IconTransformControls } from '../controls/IconTransformControls';
import { OctreeManager } from '../Octree/OctreeManager';

export class ModelRotateController {
    public transFormControls: IconTransformControls;
    public isMouseDown: boolean;

    constructor(public object: THREE.Object3D) {
        this.create();
        this.isMouseDown = false;
    }

    private create() {
        this.transFormControls = new IconTransformControls(ThreeView.get().wcCameras.camera.me, ThreeView.get().container);
        this.transFormControls.enabled = false;
        this.transFormControls.setMode('rotate');
        this.setVisible(false, true, false);
        this.transFormControls.space = 'world';

        ThreeView.get().wcItemmgr.addOtherShapes(this.transFormControls);
        this.transFormControls.attach(this.object);

        this.transFormControls.addEventListener('dragging-changed', (e: THREE.Event) => {
            console.log(`dragging-changed`);
            const control = <WalkThroughCameraControl | OrbitCameraControl>ThreeView.get().wcCameras.camera.control;
            control._instance.enabled = (!e.value);
        });

        this.transFormControls.addEventListener('mouseDown', (e) => {
            this.isMouseDown = true;
            ThreeView.get().isOperation = true;
            ThreeView.get().pickermanager.hide();

            ThreeView.get().controller.description();
        })

        this.transFormControls.addEventListener('mouseUp',(e) => {
            console.log('transformcontrol mouseUp');
            this.isMouseDown = false;
            ThreeView.get().isOperation = false;
            ThreeView.get().updateObject(this.object);
            // アイテム選択解除
            ThreeView.get().unSelectedObject();

            ThreeView.get().OctreeManager = new OctreeManager(ThreeView.get().wcItemmgr.houseData);
            // 画角内判定
            ThreeView.get().CameraTarget.getTargets(ThreeView.get().wcCameras.camera.me, ThreeView.get().OctreeManager.nodeStatus);
        });
    }

    private setVisible(isX: boolean, isY: boolean, isZ: boolean) {
        this.transFormControls.showX = isX;
        this.transFormControls.showY = isY;
        this.transFormControls.showZ = isZ;
    }

    public removeEvent = () => {
        console.log('ThreeView.get().container clickd');
        this.reset();
    }

    private reset() {
        if (this.transFormControls == null) return;
        document.removeEventListener('mousedown', this.removeEvent);
        this.transFormControls.dispose();
        this.transFormControls.detach();
        ThreeView.get().wcItemmgr.removeOtherShapes(this.transFormControls);
    }
}
